<template>
  <component
    :is="layoutName"
    :materials="materials"
    @ads:entry="onAdsEntry"
    @ads:view="onAdsView"
    @ads:click="onAdsClick"
  >
  </component>
</template>

<script>
import CMainShapePc from "./layout/CMainShapePc.vue";
import CMainShapeMobile from "./layout/CMainShapeMobile.vue";
import { LAYOUT_NAME } from "../../../adsmart-ui/settings/boards/type105.js";

export default {
  name: "AdsType105",
  components: {
    [LAYOUT_NAME.C_MAIN_SHAPE_PC]: CMainShapePc,
    [LAYOUT_NAME.C_MAIN_SHAPE_MOBILE]: CMainShapeMobile
  },
  props: {
    materials: {
      type: Array,
      required: true
    },
    layoutName: {
      type: String,
      default: ""
    }
  },
  mounted() {},
  methods: {
    onAdsEntry(materialIndex) {
      this.$emit("ads:entry", materialIndex);
    },
    onAdsView(materialIndex) {
      this.$emit("ads:view", materialIndex);
    },
    onAdsClick(linkHref, materialIndex) {
      this.$emit("ads:click", linkHref, materialIndex);
    }
  }
};
</script>

<style lang="scss">
@import "~scss/reset.scss";
@import "~scss/fontFamilyPC.scss";
</style>
